import { CapabilityIdEnum } from 'src/app/shared/capabilities-and-permissions';

import { DayRangeSelector } from '../../metrics/selectors-classes';

export class ClicksMetricHelperService {
  constructor(UserFactory, DateRangePickerDialogFactory, $translate, LocalStorageFactory, MetricsFactory, $filter, QuickRepliesFactory, AlertingFactory) {
    this.UserFactory = UserFactory;
    this.DateRangePickerDialogFactory = DateRangePickerDialogFactory;
    this.$translate = $translate;
    this.LocalStorageFactory = LocalStorageFactory;
    this.MetricsFactory = MetricsFactory;
    this.$filter = $filter;
    this.QuickRepliesFactory = QuickRepliesFactory;
    this.AlertingFactory = AlertingFactory;
  }

  maybeInitScenarioMetrics($scope, site, scenarioId) {
    $scope.clicksMetric = {
      isDisplayed: false, // controls whether the time interval selector is displayed (changed by the checkbox)
      isAvailable: false, // controls whether the checkbox is displayed at all
      metricData: null
    };
    if (this.UserFactory.hasCapabilityForAtLeastOneEnabledSite(CapabilityIdEnum.Statistics)) {
      // As the qr-clicks metric is not defined in Metrics.py anymore, let's reproduce some of it here
      const clickDateSelectorDescription = {
        'type': 'dayrange',
        'name': 'clicked_at',
        'fields': ['where:clicked_at'],
        'is_default': true
      };
      const metric = {
        'id': 'qr-clicks',
        'internal_name': 'qr-clicks'
      };
      this.initScenarioMetrics($scope, site, scenarioId, metric, clickDateSelectorDescription);
    }
  }

  // Note that this only loads the metric description and initialises the day range selector;
  // the actual metric data is retreived by the onDayRangeChange() function
  initScenarioMetrics($scope, site, scenarioId, metric, clickDateSelectorDescription) {
    $scope.clickDateSelector = new DayRangeSelector(
      site.company,
      metric,
      this.DateRangePickerDialogFactory,
      this.LocalStorageFactory,
      this.MetricsFactory,
      this.$filter,
      this.$translate
    ).create(clickDateSelectorDescription, () => this.onDayRangeChange($scope, site, scenarioId));

    $scope.clickDateSelector.load(); // will load a range from localstorage, or set the default range (the last 7 days)
    $scope.$watch('clicksMetric.isDisplayed', newValue => {
      if (newValue) {
        this.onDayRangeChange($scope, site, scenarioId);
      } else {
        $scope.clicksMetric.metricData = null;
      }
    });
    $scope.clicksMetric.isAvailable = true;
  }


  onDayRangeChange($scope, site, scenarioId) {
    $scope.clickDateSelector.save();
    const fromDate = $scope.clickDateSelector.fromDate;
    const toDate = $scope.clickDateSelector.toDate;
    this.QuickRepliesFactory.getScenarioClicks(site.company.id, site.id, scenarioId, fromDate, toDate)
      .then(result => $scope.clicksMetric.metricData = result.data,
        this.AlertingFactory.httpErrorHandler());
  }



  static ClicksMetricHelperFactory(UserFactory, DateRangePickerDialogFactory, $translate, LocalStorageFactory, MetricsFactory, $filter, QuickRepliesFactory, AlertingFactory) {
    return new ClicksMetricHelperService(UserFactory, DateRangePickerDialogFactory, $translate, LocalStorageFactory, MetricsFactory, $filter, QuickRepliesFactory, AlertingFactory);
  }
}

ClicksMetricHelperService.ClicksMetricHelperFactory.$inject =
  ['UserFactory', 'DateRangePickerDialogFactory', '$translate', 'LocalStorageFactory', 'MetricsFactory',
    '$filter', 'QuickRepliesFactory', 'AlertingFactory'];
